import React from 'react'
import { Ordering } from 'storfox-filter'

import { TAX_COLUMNS as tableColumns } from './TaxTable'

import { FILTER_NAME as name } from '../../../constants/Tax'

export const taxOrderingOptions = {
  name,
  tableColumns
}

function TaxOrderingForm (props) {
  return (
    <Ordering {...props} />
  )
}

export default TaxOrderingForm
